var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThermostat01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 5.2,
    y: 3.5,
    className: "st0",
    width: 5.6,
    height: 9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.2,3.5c0.2,0.4,5.6,9,5.6,9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 5.2,
    y1: 12.5,
    x2: 10.8,
    y2: 3.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermostat01);
export default __webpack_public_path__ + "static/media/Thermostat-01.a5206cd4f6e41fa691a3978aba880b0b.svg";
export { ForwardRef as ReactComponent };